import { Component } from '@angular/core';
import { FleetHeaderComponent } from './layout/fleetheader.component';

import { MatIconModule } from '@angular/material/icon';
import { FleetPageHeaderComponent } from './layout/fleetpage-header.component';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';

@Component({
    imports: [SharedTranslateModule, FleetPageHeaderComponent, MatIconModule],
    template: `
  <div class="dtffleet">
    <app-page-header icon="home">
      <h2>Home</h2>

      <button
        routerLink="/sales"
        mat-flat-button
        color="primary"
        class="action"
      >
        <mat-icon class="mr-2">add</mat-icon>
        <span>New sale</span>
      </button>
    </app-page-header>

    <div style="padding: 0 20px">
      Hello from Home
    </div>
    </div>
  `
})
export class FleetHomeComponent {}
